"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TrustpilotSection;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _renderRating = require("./render-rating");
var _image = require("@site/pattern-library-core/image");
var _settings = require("@site/pattern-library-core/settings");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const TrustpilotSectionWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TrustpilotSectionWrapper",
  class: "pl-t1lsl37o"
});
const Rating = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Rating",
  class: "pl-r3dhu86"
});
const Transparency = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Transparency",
  class: "pl-t2tixib"
});
const Separator = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "Separator",
  class: "pl-s1a7egke"
});
const debugToken = str => {
  const regx = /\[(?!.*\])[^[\s\]]*/;
  try {
    const {
      0: result,
      index
    } = regx.exec(str);
    if (result) {
      const closePos = index + result.length;
      return `${str.slice(0, closePos)}]${str.slice(closePos)}`;
    }
  } catch (e) {
    return str;
  }
};
const extractNumFromStr = (str = '') => {
  if (typeof str !== 'string') {
    return {
      reviewRating: 0,
      reviewCount: 0
    };
  }
  const matches = str.match(/^(\d+\.\d+).*\[(\d+(?:,\d{3})*)\]/);
  if (matches) {
    const reviewRating = parseFloat(matches[1]);
    const countValue = parseInt(matches[2].replace(/,/g, ''), 10);
    return {
      reviewRating,
      reviewCount: countValue
    };
  }
  return {
    reviewRating: 0,
    reviewCount: 0
  };
};

/**
 * Render Trustpilot Logo Section
 *
 * @param {Object} props React props for Trustpilot Logo Section
 * @param {Object} props.trustpilotLogo Trustpilot logo image URL and alt text
 * @param {number|integer} props.rating Number of stars to fill in
 * @param {string} props.transparencyLeft Text to left of pipe symbol
 * @param {string} props.transparencyRight Text to right of pipe symbol
 * @param {string} props.trustpilotUrl Url that the section should link to
 * @param {string} props.altTextForReviewStars {0} replacable string for aria-label
 * @param {boolean} props.useAggregateRatingMarkup Aggregate rating markup flag
 * @param {string} props.htmlMarkupName HTML Microdata Markup name
 * @param {string} props.htmlMarkupDescription HTML Microdata Markup Description
 * @returns {React.ReactElement} Trustpilot Logo Section
 * @public
 */
function TrustpilotSection({
  trustpilotLogo,
  rating,
  transparencyLeft,
  transparencyRight,
  trustpilotUrl,
  altTextForReviewStars,
  useAggregateRatingMarkup,
  htmlMarkupName,
  htmlMarkupDescription
}) {
  const [fullUrl, setFullUrl] = (0, _react.useState)('');
  const {
    reviewRating,
    reviewCount
  } = extractNumFromStr(transparencyLeft);
  const schemaAttributes = (0, _settings.getSchemaAttributes)();
  const formatTransparencyLeft = strOrig => {
    const str = debugToken(strOrig);
    const beforeInd = str.indexOf('[');
    const afterInd = str.indexOf(']');
    const totalReviews = str.substring(beforeInd + 1, afterInd);
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, str.substring(0, beforeInd), /*#__PURE__*/_react.default.createElement("span", {
      style: {
        fontWeight: 'bold'
      }
    }, totalReviews), str.substring(afterInd + 1));
  };
  (0, _react.useEffect)(() => {
    const baseUrl = window.location.origin;
    const path = window.location.pathname;
    setFullUrl(`${baseUrl}${path}`);
  }, []);
  return /*#__PURE__*/_react.default.createElement(TrustpilotSectionWrapper, useAggregateRatingMarkup ? schemaAttributes.product : null, useAggregateRatingMarkup && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("meta", {
    itemProp: "name",
    content: htmlMarkupName
  }), /*#__PURE__*/_react.default.createElement("meta", {
    itemProp: "description",
    content: htmlMarkupDescription
  }), /*#__PURE__*/_react.default.createElement("meta", {
    itemProp: "url",
    content: fullUrl
  })), /*#__PURE__*/_react.default.createElement("div", useAggregateRatingMarkup ? schemaAttributes.aggregateRating : null, useAggregateRatingMarkup && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("meta", {
    itemProp: "ratingValue",
    content: reviewRating.toString()
  }), /*#__PURE__*/_react.default.createElement("meta", {
    itemProp: "reviewCount",
    content: reviewCount.toString()
  })), /*#__PURE__*/_react.default.createElement("a", {
    href: trustpilotUrl,
    rel: "noreferrer",
    target: "_blank"
  }, /*#__PURE__*/_react.default.createElement(_image.LazyImage, trustpilotLogo), rating && /*#__PURE__*/_react.default.createElement(Rating, {
    role: "img",
    "aria-label": altTextForReviewStars.replace('{0}', rating)
  }, (0, _renderRating.renderRating)(rating, 36))), transparencyLeft && /*#__PURE__*/_react.default.createElement(Transparency, null, /*#__PURE__*/_react.default.createElement("a", {
    href: trustpilotUrl,
    rel: "noreferrer",
    target: "_blank"
  }, formatTransparencyLeft(transparencyLeft)), transparencyRight && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Separator, null, "|"), transparencyRight))));
}
TrustpilotSection.propTypes = {
  trustpilotLogo: _propTypes.default.shape(_image.imgPropShape).isRequired,
  // eslint-disable-next-line max-len
  rating: _propTypes.default.oneOf(_settings.TrustPilotRatings),
  transparencyLeft: _propTypes.default.string,
  transparencyRight: _propTypes.default.string,
  trustpilotUrl: _propTypes.default.string.isRequired,
  altTextForReviewStars: _propTypes.default.string.isRequired,
  useAggregateRatingMarkup: _propTypes.default.bool,
  htmlMarkupName: _propTypes.default.string,
  htmlMarkupDescription: _propTypes.default.string
};